import React from "react";
import { Instagram, ArrowUp, Youtube } from "lucide-react";

const WhatsAppIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.004 3C8.832 3 3 8.832 3 16.004c0 2.293.602 4.535 1.746 6.512L3.08 29l6.641-1.645A12.91 12.91 0 0 0 16.004 29C23.176 29 29 23.168 29 16.004 29 8.832 23.176 3 16.004 3Zm0 23.746a10.7 10.7 0 0 1-5.461-1.496l-.391-.23-3.941.973 1.051-3.844-.254-.406a10.68 10.68 0 0 1-1.645-5.739c0-5.883 4.758-10.641 10.641-10.641 5.875 0 10.633 4.758 10.633 10.641 0 5.875-4.758 10.742-10.633 10.742Zm5.836-7.969c-.32-.16-1.883-.93-2.176-1.035-.293-.109-.508-.16-.723.16-.211.32-.828 1.035-1.016 1.246-.188.215-.375.242-.695.082-.32-.16-1.352-.5-2.574-1.59-.953-.848-1.594-1.895-1.781-2.215-.188-.32-.02-.492.141-.652.145-.145.32-.375.48-.563.16-.188.215-.32.32-.535.109-.215.055-.402-.027-.563-.082-.16-.723-1.742-.988-2.387-.258-.621-.52-.535-.723-.543h-.617c-.211 0-.563.078-.855.402-.293.32-1.121 1.094-1.121 2.668s1.148 3.09 1.309 3.305c.16.211 2.258 3.449 5.473 4.836.766.332 1.363.531 1.828.68.77.246 1.469.211 2.023.129.617-.094 1.883-.77 2.148-1.512.266-.746.266-1.383.188-1.516-.078-.133-.293-.211-.613-.371Z" />
  </svg>
);

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white pt-16 md:pt-24 pb-8"
    >
      <div className="px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-8 md:gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-baseline gap-1.5">
              <span className="font-display font-black uppercase tracking-tighter text-5xl md:text-7xl">
                Dot Media
              </span>
              <span className="w-3 h-3 md:w-4 md:h-4 bg-[#E60000] rounded-full inline-block translate-y-[-4px]" />
            </div>

            <p className="mt-6 max-w-md text-white/70 text-base leading-relaxed">
              We're the dot to your marketing. Strategy, content, influencers,
              and production — under one roof, to one outcome.
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <h4 className="text-[11px] tracking-[0.28em] uppercase font-bold text-white/50 mb-4">
              Studio
            </h4>

            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="#campaigns"
                  className="hover:text-[#E60000] transition-colors"
                >
                  Campaigns
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="hover:text-[#E60000] transition-colors"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="#reels"
                  className="hover:text-[#E60000] transition-colors"
                >
                  Reels
                </a>
              </li>
              <li>
                <a
                  href="#team"
                  className="hover:text-[#E60000] transition-colors"
                >
                  Team
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-12 sm:col-span-6 md:col-span-3">
            <h4 className="text-[11px] tracking-[0.28em] uppercase font-bold text-white/50 mb-4">
              Contact
            </h4>

            <ul className="space-y-2 text-sm text-white/75">
              <li>
                <a
                  href="mailto:hello@dotmedia.co.in"
                  className="hover:text-[#E60000] transition-colors"
                >
                  hello@dotmedia.co.in
                </a>
              </li>

              <li>
                <a
                  href="mailto:dotmedia.co.in@gmail.com"
                  className="hover:text-[#E60000] transition-colors"
                >
                  dotmedia.co.in@gmail.com
                </a>
              </li>

              <li>
                <a
                  href="tel:+917075772733"
                  className="hover:text-[#E60000] transition-colors"
                >
                  Mobile: +91 7075772733
                </a>
              </li>

              <li>
                <a
                  href="tel:+918106600391"
                  className="hover:text-[#E60000] transition-colors"
                >
                  Office: +91 8106600391
                </a>
              </li>

              <li className="text-white/50 pt-2">
                Hyderabad · Bengaluru · Visakhapatnam
              </li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-2">
            <h4 className="text-[11px] tracking-[0.28em] uppercase font-bold text-white/50 mb-4">
              Social
            </h4>

            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/dotmedia.india?igsh=MTkzeXVlNzU5bmdyNA=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-12 h-12 border border-white/30 hover:bg-[#E60000] hover:border-[#E60000] flex items-center justify-center transition-colors"
              >
                <Instagram size={24} />
              </a>

              <a
                href="https://wa.me/917075772733"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp"
                className="w-12 h-12 border border-white/30 hover:bg-[#E60000] hover:border-[#E60000] flex items-center justify-center transition-colors"
              >
                <WhatsAppIcon size={26} />
              </a>

              <a
                href="https://www.youtube.com/@DotMediaIndia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                data-testid="footer-youtube"
                className="w-12 h-12 border border-white/30 hover:bg-[#E60000] hover:border-[#E60000] flex items-center justify-center transition-colors"
              >
                <Youtube size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 md:mt-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] tracking-[0.22em] uppercase font-bold text-white/50 border-t border-white/15 pt-8 md:pt-10">
          <span>© {year} Dot Media — All rights reserved.</span>

          <div className="flex items-center gap-5">
            <a
              href="#top"
              className="hover:text-white flex items-center gap-2"
              data-testid="footer-back-to-top"
            >
              Back to top <ArrowUp size={12} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
